import { formatEin } from 'utils'

function displayEin(ein, defaultValue = '-') {
  return ein ? formatEin(ein) : defaultValue
}

export default displayEin
